import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  registerables as registerablesJS,
} from "chart.js";
import { Line } from "react-chartjs-2";
import _ from "lodash";

import { getAntiCorruptionTraining } from "../../../redux/actions";

import useStyles from "./styles";
import { getCookie } from "../../../services/cookie";

ChartJS.register(...registerablesJS);
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const AntiCorruptionTrainingGraph = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const role = getCookie("role");
  const companyId = getCookie("companyId");

  const employeeData = useSelector(
    (state) => state.dashboard.getAntiCorruptionTraining.data.response
  );
  const employeeDataStatus = useSelector(
    (state) => state.dashboard.getAntiCorruptionTraining.data.status
  );

  useEffect(() => {
    !props.refreshContent &&
      dispatch(getAntiCorruptionTraining(props.filter, role, companyId));
  }, [dispatch, props.filter]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          fontColor: "rgba(0,0,0,.4)",
        },
        align: "end",
        position: "bottom",
      },
      title: {
        align: "start",
        display: true,
        text: "Anti-Corruption Training",
        color: "black",
        padding: {
          bottom: 20,
        },
        font: {
          size: 18,
          family: "Inter",
          weight: "400",
        },
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "No. of Trainings conducted",
          color: "#4F4F4F",
          font: {
            size: 12,
            family: "Inter",
            weight: "400",
          },
        },
        ticks: {
          color: "black",
          beginAtZero: true,
        },
        grid: {
          display: false,
        },
      },
      x: {
        title: {
          display: true,
          text: "Duration",
          color: "#4F4F4F",
          font: {
            size: 12,
            family: "Inter",
            weight: "400",
          },
        },
        ticks: {
          color: "black",
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const data = {
    labels: _.map(employeeData, (item) => item.year),
    datasets: [
      {
        label: "Trainings Conducted",
        data: _.map(employeeData, (item) => item.number_of_training_conducted),
        color: "black",
        backgroundColor: "#FFC757",
        borderColor: "#FFC757",
        pointBackgroundColor: "#6FBFBA",
        pointRadius: 5,
      },
    ],
  };

  return (
    <Paper className={classes.container}>
      {employeeDataStatus === true ? (
        <Line options={options} data={data} height={360} width={560} />
      ) : (
        "Data loading..."
      )}
    </Paper>
  );
};

export default AntiCorruptionTrainingGraph;
